import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { MatTabChangeEvent, MatTabGroup, MatTab, MatTabLabel } from '@angular/material/tabs';
import { Store } from '@ngrx/store';
import { combineLatest, Subscription } from 'rxjs';
import { AppState } from 'src/app/@store/app.reducers';
import { selectDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { MatTableDataSource } from '@angular/material/table';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { CrearActualizarServiciosAseguradoComponent } from '../../@components/crear-actualizar-servicios-asegurado/crear-actualizar-servicios-asegurado.component';
import { CrearActualizarServiciosTerceroComponent } from '../../@components/crear-actualizar-servicios-tercero/crear-actualizar-servicios-tercero.component';

@Component({
    selector: 'app-seccion-servicios',
    templateUrl: './seccion-servicios.component.html',
    styleUrls: ['./seccion-servicios.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatTabGroup, MatTab, MatTabLabel, CrearActualizarServiciosAseguradoComponent, CrearActualizarServiciosTerceroComponent]
})
export class SeccionServiciosComponent implements OnDestroy {

  public tabIndex: number = 0;
  public catTabsServicios = [
    { id: 1, nombre: 'Asegurados' },
    { id: 2, nombre: 'Terceros' },
  ];

  public detalleSiniestro = null;
  public siniestroSeleccionado: string;
  public datosServicios = {
    Asegurados: new MatTableDataSource([]),
    Terceros: new MatTableDataSource([]),
  }
  public listaObservables = new Subscription();

  constructor(
    public dialogRef: MatDialogRef<SeccionServiciosComponent>,
    private store: Store<AppState>,
    private complementoWebService: ComplementoWebService,
    private procesosComunesService: ProcesosComunesComplementoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.obtenerReduxState();
  }

  ngOnDestroy(): void {
    this.listaObservables.unsubscribe();
  }

  obtenerReduxState() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleSiniestro]) => {
      this.siniestroSeleccionado = siniestro;
      this.detalleSiniestro = { ...detalleSiniestro };
      this.consultarServiciosGeneral(siniestro);
    });
    this.listaObservables.add(subsComplemento);
  }

  closeDialog(opcion: string) {
    if (opcion == 'Cancelar') this.dialogRef.close();
    if (opcion == 'Aceptar') this.dialogRef.close();
  }

  onTabChange(event: MatTabChangeEvent) {
    this.tabIndex = Number(event.index + 1);
    this.consultarServiciosGeneral(this.siniestroSeleccionado);
  }

  consultarServiciosGeneral(siniestro: string) {
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(siniestro);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaServiciosGeneral(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Resultado.Asegurado.length || value.Resultado.Tercero.length) {
          this.datosServicios.Asegurados = new MatTableDataSource(value.Resultado.Asegurado);
          this.datosServicios.Terceros = new MatTableDataSource(value.Resultado.Tercero);
        } else {
          // this.procesosComunesService.alertaGeneralComplemento('Aviso', `No se encontró ningún servicio`, 'info', false, true);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No se pudo consultar la información de los servicios.' }));
      },
    })
  }

  procesarEventosServicios(evento: { nombre: string, valor: any }) {
    if (evento.nombre == 'ACTUALIZAR_SERVICIOS') {
      this.consultarServiciosGeneral(this.siniestroSeleccionado);
    }
  }
}
